
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!calendar.missing_due_date_dialog";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'calendar/missingDueDateDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0));
  }

function program3(depth0,data) {
  
  var buffer = "";
  buffer += "<li><b>"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</b></li>";
  return buffer;
  }

  buffer += "<div>\n  <p>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_all_sections_will_be_assigned_this_item_4e2b8eaa", "Not all sections will be assigned this item.", options) : helperMissing.call(depth0, "t", "not_all_sections_will_be_assigned_this_item_4e2b8eaa", "Not all sections will be assigned this item.", options)))
    + "\n  </p>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "would_you_like_to_go_back_to_include_1d279044", "Would you like to go back to include:", options) : helperMissing.call(depth0, "t", "would_you_like_to_go_back_to_include_1d279044", "Would you like to go back to include:", options)))
    + "\n  <ul aria-label=\"";
  stack1 = (helper = helpers.toSentence || (depth0 && depth0.toSentence),options={hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.sections), options) : helperMissing.call(depth0, "toSentence", (depth0 && depth0.sections), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.sections), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </ul>\n\n  <div class=\"button-container form-actions\">\n    <button type=\"button\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "go_back_ed239e69", "Go Back", options) : helperMissing.call(depth0, "t", "go_back_ed239e69", "Go Back", options)))
    + "</button>\n    <button type=\"button\" class=\"btn btn-primary\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "continue_ac067716", "Continue", options) : helperMissing.call(depth0, "t", "continue_ac067716", "Continue", options)))
    + "\n    </button>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  